var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalItem)?_c('div',{staticClass:"pagination-box"},[_c('button',{staticClass:"btn-paging left",on:{"click":function($event){return _vm.listing('prev')}}}),_vm._l((_vm.pagingArr),function(cnt){return _c('button',{key:cnt,class:[
			'btn-paging',
			{ 'btn-paging--selected': _vm.currPage === cnt },
		],on:{"click":function($event){return _vm.to(cnt)}}},[_vm._v(" "+_vm._s(cnt)+" ")])}),_c('button',{staticClass:"btn-paging right",on:{"click":function($event){return _vm.listing('next')}}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }